import React, { Component, Fragment } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import moment from "moment";
import { Row, Col, Tabs, Tab } from "react-bootstrap";
import ReactTable from "react-table";
import AdminService from "../../../services/AdminService";
import API from "../../../services/APIService";
import HandleError from "../../../services/HandleError";
import Materialicon from "../../helpers/Materialicon";
import LoadingSVG from "../../helpers/LoadingSVG";
import { hasPermission, hasRole } from "../../helpers/Permissions";

class UserInfo extends Component {
	state = {
		isLoadingUserInfo: true,
		userInfo: {},
		isAssistant: hasRole(6)
	}

	componentDidMount = () => { this.getUserData(); }

	getUserData = () => {
		const { userId } = this.props.match.params;
		this.userAdminService.show(userId).then((res) => {
			const user = res.data.user;
			const role = (user.roles && Array.isArray(user.roles) && user.roles[0] ? user.roles[0].id : null);
			if (user) {
				this.setState({
					isLoadingUserInfo: false,
					roleId: role,
					userInfo: {
						id: this.loadSingleField(user.id),
						role: (user.roles && Array.isArray(user.roles) && user.roles[0] ? user.roles[0].name : null),
						roles: this.loadAllRoles(user),
						firstName: this.loadSingleField(user.first_name),
						lastName: this.loadSingleField(user.last_name),
						fullName: this.loadSingleField(user.full_name),
						email: this.loadSingleField(user.email),
						country_name: this.loadSingleField(user.country_name),
						skype: this.loadSingleField(user.skype_name),
						cellular: this.loadSingleField(user.cellular),
						status: this.loadStatus(user.status_id),
						userPhoto: user.image || null,
						address: this.loadAttributeByName(user.attributes, "address"),
						emergency_contact: this.loadAttributeByName(user.attributes, "emergency_contact"),
					}
				});
				// if user is employee or admin, load employee/admin fields and fill them data
				if (role === 2 || role === 4) {
					this.loadEmployeOrAdminFields(user, res.data.reports_to_user);
				}

				// if user is customer, load customer fields and fill with them data
				if (role === 3) {
					this.loadCustomerFields(user, res.data.availableAreas);
				}
			}
		}).catch((err) => {
			this.setState({ isLoadingUserInfo: false });
			HandleError(err);
		});
	}

	loadSingleField = (field) => field || null

	loadStatus = (status) => {
		switch (status) {
		case "4":
			return "Active";
		case "5":
			return "Inactive";
		default:
			return "";
		}
	}

	loadAllRoles = (user) => {
		if (user.roles && Array.isArray(user.roles)) {
			return user.roles.map((item) => ({ id: item.id, name: item.name }));
		}
		return [];
	}

	loadEmployeOrAdminFields = (user, reports_to_user) => {
		this.setState({
			...this.state,
			userInfo: {
				...this.state.userInfo,
				skills: this.loadUserSkills(user.skills),
				title: this.loadAttributeByName(user.attributes, "title"),
				salaries: this.loadUserSalaries(user.salaries),
				insurance_nr: this.loadAttributeByName(user.attributes, "insurance_nr"),
				personal_code: this.loadAttributeByName(user.attributes, "personal_code"),
				bank_account: this.loadAttributeByName(user.attributes, "bank_account"),
				reports_to: this.loadSingleField(reports_to_user && reports_to_user.full_name)
			},
		});
	}

	loadCustomerFields = (user) => {
		const paymentCondition = (user.payment_conditions && Array.isArray(user.payment_conditions) && user.payment_conditions[0] ? user.payment_conditions[0] : null);
		this.setState({
			...this.state,
			userInfo: {
				...this.state.userInfo,
				areas: this.loadUserAreas(user.areas),
				full_company_name: this.loadAttributeByName(user.attributes, "full_company_name"),
				administrator: this.loadAttributeByName(user.attributes, "administrator"),
				administrator_email: this.loadAttributeByName(user.attributes, "administrator_email"),
				point_of_reference_email: this.loadAttributeByName(user.attributes, "point_of_reference_email"),
				point_of_reference_cel: this.loadAttributeByName(user.attributes, "point_of_reference_cel"),
				priority_level: this.loadAttributeByName(user.attributes, "priority_level"),
				paymentCondition: (paymentCondition && `${paymentCondition.days} days`)
			},
		});
	}

	loadAttributeByName = (attributes, name) => {
		let attribute = null;
		if (attributes && Array.isArray(attributes)) {
			attribute = attributes.find((item) => (item.name === name));
		}
		if (attribute && attribute.value) { return attribute.value; }
		return null;
	}

	loadUserSkills = (skills) => {
		if (skills && Array.isArray(skills)) {
			return skills.map((item) => ({ id: item.id, name: item.name, skill_id: item.id, value: item.pivot && item.pivot.value }));
		}
		return [];
	}

	loadUserAreas = (areas) => {
		if (areas && Array.isArray(areas)) {
			return areas.map((item) => ({ id: item.id, name: item.name, area_id: item.id, value: item.pivot && item.pivot.price, hours: item.pivot && item.pivot.price }));
		}
		return [];
	}

	loadUserSalaries = (salaries) => {
		if (salaries && Array.isArray(salaries)) {
			return salaries.map((salary) => ({ id: salary.id, from: salary.from, salary: salary.salary }));
		}
		return [];
	}

	staticUrl = API.getStaticUrl();
	userAdminService = new AdminService(this, "users")

	render() {
		const canEditUser = hasPermission("user.update");
		const { isLoadingUserInfo, userInfo, roleId } = this.state;
		return (
			<div className="crud-page user-info">
				<div className="container-fluid">
					<section className="actions">
						<Row>
							<Col md={6} sm={6} xs={12}>
								<h2 className="page-title">{userInfo.fullName}</h2>
							</Col>
							<Col md={6} sm={6} xs={12}>
								<Link to="/users" className="pull-right btn-add-big btn btn-default">
									<Materialicon icon="keyboard_arrow_left" /> Back to Users
    							</Link>
							</Col>
						</Row>
					</section>
					{isLoadingUserInfo ? <LoadingSVG /> :
						<React.Fragment>
							<Row className="user-info-container">
								<Col lg={3} md={4} sm={5} xs={12} className="info-left fadeInLoadUp">
									<div className="card card-top-border">
										<div className="user-image">
											<img src={`${this.staticUrl}/uploads/${userInfo.userPhoto || "defaultUserImage.png"}`} alt="user-avatar" />
										</div>
										<h2 className="user-name">{userInfo.fullName}</h2>
										{userInfo.roles && userInfo.roles.map((item) => (
											<h3 className="user-role" key={item.id}>{item.name}</h3>
										))}
										{canEditUser && <Link to={`/users/${userInfo.id}/edit`} className="btn btn-primary user-edit">Edit</Link>}
									</div>
								</Col>
								<Col lg={9} md={8} sm={7} xs={12} className="info-right fadeInLoadUp">
									<div className="card card-top-border">
										<Tabs defaultActiveKey={1} id="user-profile-tab-editor" className="card-tab">
											<Tab eventKey={1} title="General Info">
												<div className="tab-container">
													<ul className="tab-list">
														<li>
															<h4 className="info-attr">First name:</h4>
															<h5 className="info-text">{userInfo.firstName}</h5>
														</li>
														<li>
															<h4 className="info-attr">Last name:</h4>
															<h5 className="info-text">{userInfo.lastName}</h5>
														</li>
														<li>
															<h4 className="info-attr">Email:</h4>
															<h5 className="info-text">{userInfo.email}</h5>
														</li>
														<li>
															<h4 className="info-attr">Country:</h4>
															<h5 className="info-text">{userInfo.country_name}</h5>
														</li>
														<li>
															<h4 className="info-attr">Skype:</h4>
															<h5 className="info-text">{userInfo.skype}</h5>
														</li>
														{userInfo.cellular &&
															<li>
																<h4 className="info-attr">Cellular:</h4>
																<h5 className="info-text">{userInfo.cellular}</h5>
															</li>
														}
														<li>
															<h4 className="info-attr">Status:</h4>
															<h5 className="info-text">{userInfo.status}</h5>
														</li>
													</ul>
												</div>
											</Tab>
											{(roleId === 4 || roleId === 2) &&
												<Tab eventKey={2} title="Employee Info">
													<div className="tab-container">
														<ul className="tab-list">
															<li>
																<h4 className="info-attr">Reports to:</h4>
																<h5 className="info-text">{userInfo.reports_to}</h5>
															</li>
															<li>
																<h4 className="info-attr">Title:</h4>
																<h5 className="info-text">{userInfo.title}</h5>
															</li>
															<li>
																<h4 className="info-attr">Address:</h4>
																<h5 className="info-text">{userInfo.address}</h5>
															</li>
															<li>
																<h4 className="info-attr">Emergency contact:</h4>
																<h5 className="info-text">{userInfo.emergency_contact}</h5>
															</li>
															<li>
																<h4 className="info-attr">Insurance Number:</h4>
																<h5 className="info-text">{userInfo.insurance_nr}</h5>
															</li>
															<li>
																<h4 className="info-attr">Personal Code:</h4>
																<h5 className="info-text">{userInfo.personal_code}</h5>
															</li>
															<li>
																<h4 className="info-attr">Bank Account:</h4>
																<h5 className="info-text">{userInfo.bank_account}</h5>
															</li>
															{this.state.isAssistant ? null :
																<li className="salary-item">
																	<h4 className="info-attr">Salary:</h4>
																	{userInfo.salaries && userInfo.salaries.map((item) => (
																		<h5 className="info-text" key={item.id}>
																			<span>{moment(item.from).format("DD-MM-YYYY")}</span>: <span> {item.salary}€</span>,
																		</h5>
																	))}
																</li>
															}
														</ul>
													</div>
												</Tab>
											}
											{(roleId === 4 || roleId === 2) &&
												<Tab eventKey={3} title="Skills">
													<div className="tab-container">
														<ReactTable
															columns={[
																{
																	Header: "Skill",
																	accessor: "name",
																	Cell: row => <div className="text-center">{row.value}</div>
																}, {
																	Header: "Skill value",
																	accessor: "value",
																	Cell: row => <div className="text-center">{row.value}</div>
																}
															]}
															manual
															data={userInfo.skills}
															sortable={false}
															defaultPageSize={-1}
															showPagination={false}
														/>
													</div>
												</Tab>
											}

											{roleId === 3 &&
												<Tab eventKey={4} title="Customer Info">
													<div className="tab-container">
														<ul className="tab-list">
															<li>
																<h4 className="info-attr">Address:</h4>
																<h5 className="info-text">{userInfo.address}</h5>
															</li>
															<li>
																<h4 className="info-attr">Emergency contact:</h4>
																<h5 className="info-text">{userInfo.emergency_contact}</h5>
															</li>
															<li>
																<h4 className="info-attr">Company Name:</h4>
																<h5 className="info-text">{userInfo.full_company_name}</h5>
															</li>
															<li>
																<h4 className="info-attr">Administrator:</h4>
																<h5 className="info-text">{userInfo.administrator}</h5>
															</li>
															<li>
																<h4 className="info-attr">Administrator Email:</h4>
																<h5 className="info-text">{userInfo.administrator_email}</h5>
															</li>
															<li>
																<h4 className="info-attr">Point of reference email:</h4>
																<h5 className="info-text">{userInfo.point_of_reference_email}</h5>
															</li>
															<li>
																<h4 className="info-attr">Point of reference <br /> cellular:</h4>
																<h5 className="info-text">{userInfo.point_of_reference_cel}</h5>
															</li>
															<li>
																<h4 className="info-attr">Priority Level:</h4>
																<h5 className="info-text">{userInfo.priority_level}</h5>
															</li>
															<li>
																<h4 className="info-attr">Payment Condition:</h4>
																<h5 className="info-text">{userInfo.paymentCondition}</h5>
															</li>
														</ul>
													</div>
												</Tab>
											}
											{roleId === 3 &&
												<Tab eventKey={5} title="Areas">
													<div className="tab-container">
														<ReactTable
															columns={[
																{
																	Header: "Area",
																	accessor: "name",
																	Cell: row => <div className="text-center">{row.value}</div>
																}, {
																	Header: "Area value",
																	accessor: "value",
																	Cell: row => <div className="text-center">{row.value}</div>
																}
															]}
															manual
															data={userInfo.areas}
															sortable={false}
															defaultPageSize={-1}
															showPagination={false}
														/>
													</div>
												</Tab>
											}
										</Tabs>
									</div>
								</Col>
							</Row>
						</React.Fragment>
					}
				</div>
			</div>
		);
	}
}
UserInfo.propTypes = {
	match: PropTypes.shape({
		params: PropTypes.shape({
			userId: PropTypes.string.isRequired
		})
	}).isRequired,
};


export default UserInfo;


// WEBPACK FOOTER //
// ./src/components/pages/users/UserInfo.js